import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08f8066e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "card-title text-start mb-0" }, "Rate List")
], -1))
const _hoisted_4 = { class: "card-datatable table-responsive" }
const _hoisted_5 = { class: "dataTables_wrapper dt-bootstrap5 no-footer" }
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-2\" data-v-08f8066e><div class=\"me-3\" data-v-08f8066e><div class=\"dataTables_length\" data-v-08f8066e><label data-v-08f8066e><select aria-controls=\"DataTables_Table_0\" class=\"form-select\" name=\"DataTables_Table_0_length\" data-v-08f8066e><option value=\"10\" data-v-08f8066e>10</option><option value=\"25\" data-v-08f8066e>25</option><option value=\"50\" data-v-08f8066e>50</option><option value=\"100\" data-v-08f8066e>100</option></select></label></div></div></div>", 1)
const _hoisted_8 = { class: "col-md-10" }
const _hoisted_9 = { class: "dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-3 mb-md-0" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "datatables-users table border-top dataTable no-footer dtr-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Distance Type"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Per Unit Price"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Base Price"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Base Unit"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "2nd Package "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "3rd Package "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "4rt Package"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "user"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Action")
  ])
], -1))
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "btn-group mr-2" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  class: "py-0",
  colspan: "11"
}
const _hoisted_29 = { class: "row mx-0 py-3" }
const _hoisted_30 = { class: "table table-sm" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-start",
  scope: "col"
}, "#", -1))
const _hoisted_32 = {
  class: "text-start",
  scope: "col"
}
const _hoisted_33 = {
  class: "text-start",
  scope: "col"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-start",
  scope: "col"
}, "Range price", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-start",
  scope: "col"
}, "Rate range Type", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-start",
  scope: "col"
}, "Action", -1))
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "text-start" }
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = { class: "text-start" }
const _hoisted_43 = { class: "btn-group mr-2" }
const _hoisted_44 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-primary align-self-center",
                    to: "/rates/create"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add Rate")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rates, (rate) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: rate.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(rate.id), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(rate.distance_type), 1),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(rate.per_unit_price), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(rate.base_price), 1),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(rate.base_unit), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(rate.second_package_price), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(rate.third_package_price), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(rate.fourth_package_price), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(rate.city?.name), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(rate.user?.full_name), 1),
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("a", {
                                class: "btn btn-sm btn-primary me-2",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => ($setup.select(rate.id))
                              }, " View", 8, _hoisted_26),
                              _createVNode(_component_router_link, {
                                to: `/rates/detail/${rate.id}`,
                                class: "btn btn-sm btn-success me-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Detail ")
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createVNode(_component_router_link, {
                                to: `/rates/edit/${rate.id}`,
                                class: "btn btn-sm btn-secondary me-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Edit ")
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("a", {
                                class: "btn btn-sm btn-danger me-2",
                                onClick: ($event: any) => ($setup.del(rate.id))
                              }, " Delete", 8, _hoisted_27)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_28, [
                            _createElementVNode("div", {
                              class: _normalizeClass([$setup.selected=== rate.id ? 'show': 'hide' , "overflow-hidden"])
                            }, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_router_link, {
                                  to: `/rateranges/create/${$setup.selected}`,
                                  class: "btn btn-sm btn-secondary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Add Rate Range ")
                                  ]),
                                  _: 1
                                }, 8, ["to"]),
                                _createElementVNode("table", _hoisted_30, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_31,
                                      _createElementVNode("th", _hoisted_32, "Start Range " + _toDisplayString(rate.distance_type), 1),
                                      _createElementVNode("th", _hoisted_33, "End Range " + _toDisplayString(rate.distance_type), 1),
                                      _hoisted_34,
                                      _hoisted_35,
                                      _hoisted_36
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rate.rateranges, (raterange) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: raterange.id
                                      }, [
                                        _createElementVNode("td", _hoisted_37, _toDisplayString(raterange.id), 1),
                                        _createElementVNode("td", _hoisted_38, _toDisplayString(raterange.start_range), 1),
                                        _createElementVNode("td", _hoisted_39, _toDisplayString(raterange.end_range), 1),
                                        _createElementVNode("td", _hoisted_40, _toDisplayString(raterange.range_price), 1),
                                        _createElementVNode("td", _hoisted_41, _toDisplayString(raterange.rate_price_type), 1),
                                        _createElementVNode("td", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createVNode(_component_router_link, {
                                              to: `/rateranges/${raterange.id}/edit`,
                                              class: "btn btn-sm btn-secondary me-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Edit ")
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]),
                                            _createElementVNode("a", {
                                              class: "btn btn-sm btn-danger me-2",
                                              onClick: ($event: any) => ($setup.delraterange(raterange.id))
                                            }, " Delete", 8, _hoisted_44)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ], 2)
                          ])
                        ])
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}